import * as React from 'react';
import { UitkRemovablePill } from 'uitk-react-pill';
import { UitkTertiaryButton, UitkButtonSize } from 'uitk-react-button';
import { classNames, liveAnnounce } from 'uitk-react-utils';
import { useLocalization } from '@shared-ui/localization-context';
import styles from './uitk-typeahead.css';

/* eslint-disable react/require-default-props */
var getClassNameList = classNames.bind(styles);
/* eslint-disable prefer-arrow/prefer-arrow-functions */
function UitkTypeaheadSelections(props) {
    var headingText = props.headingText, _a = props.hideHeading, hideHeading = _a === void 0 ? false : _a, typeaheadLabel = props.typeaheadLabel, _b = props.stid, stid = _b === void 0 ? '' : _b, _c = props.values, values = _c === void 0 ? [] : _c, 
    /* eslint-disable @typescript-eslint/no-empty-function */
    _d = props.onItemRemove, 
    /* eslint-disable @typescript-eslint/no-empty-function */
    onItemRemove = _d === void 0 ? function () { } : _d, 
    /* eslint-disable @typescript-eslint/no-empty-function */
    _e = props.onClear, 
    /* eslint-disable @typescript-eslint/no-empty-function */
    onClear = _e === void 0 ? function () { } : _e, clearAllText = props.clearAllText, className = props.className;
    var l10n = useLocalization();
    var clearAll = clearAllText !== null && clearAllText !== void 0 ? clearAllText : l10n.formatText('typeahead.mulselect.clearAll');
    var heading = headingText !== null && headingText !== void 0 ? headingText : l10n.formatText('typeahead.multiselect.selectedItemHeading');
    var handleRemove = function (value, index) {
        liveAnnounce(l10n.formatText('typeahead.removeSelection', value));
        onItemRemove(index);
    };
    var handleClear = function () {
        liveAnnounce(l10n.formatText('typeahead.clearAllSelections', typeaheadLabel));
        onClear();
    };
    return (React.createElement("div", { className: getClassNameList('uitk-typeahead-selections', className) },
        !hideHeading && heading && values.length > 0 ? (React.createElement("div", { className: getClassNameList('uitk-typeahead-result-title-label', 'truncate') }, heading)) : null,
        React.createElement("div", { className: getClassNameList('uitk-typeahead-pills'), "data-stid": stid },
            values.map(function (value, index) { return (React.createElement(UitkRemovablePill, { onClick: function () { return handleRemove(value, index); }, id: "".concat(stid, "-pill-").concat(index), key: "".concat(stid, "-pill-").concat(index), className: getClassNameList('uitk-spacing-margin-block-one') }, value)); }),
            values.length ? (React.createElement(UitkTertiaryButton, { onClick: handleClear, size: UitkButtonSize.SMALL }, clearAll)) : null)));
}

export { UitkTypeaheadSelections };
